<template>
  <div
    data-view="app"
    :data-nav="navOpen ? 'open' : 'closed'"
    :data-font="font"
  >
    <NavHeader :nav-open="navOpen" @header-clicked="toggleNav" />
    <NavSidebar :nav-open="navOpen" />
    <RouterView />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

import { Font } from '@/js/api';
import NavHeader from '@/js/components/navigation/header.vue';
import NavSidebar from '@/js/components/navigation/sidebar.vue';
import { useRootStore } from '@/js/stores/root';
import { useUserStore } from '@/js/stores/user';

export default defineComponent({
  name: 'AppView',
  components: {
    NavHeader,
    NavSidebar,
  },
  setup() {
    const rootStore = useRootStore();
    const userStore = useUserStore();
    const navOpen = computed(() => rootStore.navOpen);
    const toggleNav = computed(() => rootStore.toggleNav);
    const font = computed(() => userStore.user?.font ?? Font.SERIF);

    return {
      font,
      navOpen,
      toggleNav,
    };
  },
});
</script>
